export default __webpack_public_path__ + "static/media/IBMIRL.0b0f31b4.jpg";